export const AVAILABLE_OFFICER_ACTIONS = {
  SET_STATE: 'set-state',
  UPDATE_AVAILABLE_OFFICER: 'update-available-officer',
}